<template>
    <div class="food-map-container">
      <header class="food-header">
        <div class="header-content">
          <h1 class="main-title">山西特色美食地图</h1>
          <p class="subtitle">品味三晋大地的十八种传统美食</p>
        </div>
      </header>
  
      <section class="intro-section">
        <div class="intro-content">
          <div class="intro-text">
            <h2>山西美食文化</h2>
            <p>山西，这片黄土高原上的古老土地，孕育了丰富多彩的美食文化。从刀削面到老陈醋，从平遥牛肉到太谷饼，山西美食以其独特的风味和精湛的工艺闻名于世。</p>
            <p>山西面食种类繁多，工艺精细，被誉为"中国面食博物馆"；山西老陈醋更是中国四大名醋之首，有"醋都"之称。让我们一起踏上这场舌尖上的山西之旅，领略三晋大地的美食魅力。</p>
          </div>
          <div class="intro-stats">
            <div class="stat-item">
              <div class="stat-number">18</div>
              <div class="stat-label">特色美食</div>
            </div>
            <div class="stat-item">
              <div class="stat-number">11</div>
              <div class="stat-label">地市分布</div>
            </div>
            <div class="stat-item">
              <div class="stat-number">2000+</div>
              <div class="stat-label">年饮食历史</div>
            </div>
          </div>
        </div>
      </section>
  
      <section class="map-section">
        <h2 class="section-title">
          <span class="title-icon">🍜</span>
          美食地图
          <div class="title-line"></div>
        </h2>
        
        <div class="map-container">
          <div class="shanxi-map">
            <img src="/images/map/攻略地图封面.png" alt="山西地图" class="map-image">
            
            <!-- 地图上的美食标记点 -->
            <div class="map-marker" style="top: 20%; left: 45%;" @click="selectFood(0)">
              <div class="marker-dot"></div>
              <div class="marker-label">太原</div>
            </div>
            
            <div class="map-marker" style="top: 10%; left: 30%;" @click="selectFood(1)">
              <div class="marker-dot"></div>
              <div class="marker-label">大同</div>
            </div>
            
            <div class="map-marker" style="top: 30%; left: 50%;" @click="selectFood(2)">
              <div class="marker-dot"></div>
              <div class="marker-label">晋中</div>
            </div>
            
            <div class="map-marker" style="top: 40%; left: 40%;" @click="selectFood(3)">
              <div class="marker-dot"></div>
              <div class="marker-label">临汾</div>
            </div>
            
            <div class="map-marker" style="top: 50%; left: 45%;" @click="selectFood(4)">
              <div class="marker-dot"></div>
              <div class="marker-label">运城</div>
            </div>
            
            <div class="map-marker" style="top: 25%; left: 35%;" @click="selectFood(5)">
              <div class="marker-dot"></div>
              <div class="marker-label">忻州</div>
            </div>
            
            <div class="map-marker" style="top: 35%; left: 30%;" @click="selectFood(6)">
              <div class="marker-dot"></div>
              <div class="marker-label">吕梁</div>
            </div>
            
            <div class="map-marker" style="top: 15%; left: 55%;" @click="selectFood(7)">
              <div class="marker-dot"></div>
              <div class="marker-label">朔州</div>
            </div>
            
            <div class="map-marker" style="top: 45%; left: 55%;" @click="selectFood(8)">
              <div class="marker-dot"></div>
              <div class="marker-label">长治</div>
            </div>
            
            <div class="map-marker" style="top: 55%; left: 55%;" @click="selectFood(9)">
              <div class="marker-dot"></div>
              <div class="marker-label">晋城</div>
            </div>
            
            <div class="map-marker" style="top: 30%; left: 60%;" @click="selectFood(10)">
              <div class="marker-dot"></div>
              <div class="marker-label">阳泉</div>
            </div>
          </div>
        </div>
      </section>
  
      <section class="food-list-section">
        <h2 class="section-title">
          <span class="title-icon">🍽️</span>
          十八种特色美食
          <div class="title-line"></div>
        </h2>
        
        <div class="food-filter">
          <button 
            class="filter-button" 
            :class="{ active: activeFilter === 'all' }" 
            @click="activeFilter = 'all'"
          >
            全部美食
          </button>
          <button 
            class="filter-button" 
            :class="{ active: activeFilter === 'noodles' }" 
            @click="activeFilter = 'noodles'"
          >
            特色面食
          </button>
          <button 
            class="filter-button" 
            :class="{ active: activeFilter === 'snacks' }" 
            @click="activeFilter = 'snacks'"
          >
            风味小吃
          </button>
          <button 
            class="filter-button" 
            :class="{ active: activeFilter === 'dishes' }" 
            @click="activeFilter = 'dishes'"
          >
            传统菜肴
          </button>
        </div>
        
        <div class="food-grid">
          <div 
            v-for="(food, index) in filteredFoods" 
            :key="index" 
            class="food-card"
            :class="{ 'active': selectedFood === index }"
            @click="selectFood(index)"
          >
            <div class="food-image">
              <img :src="food.image" :alt="food.name">
              <div class="food-region">{{ food.region }}</div>
            </div>
            <div class="food-content">
              <h3 class="food-title">{{ food.name }}</h3>
              <p class="food-desc">{{ food.description }}</p>
              <div class="food-tags">
                <span class="food-tag" v-for="(tag, tagIndex) in food.tags" :key="tagIndex">{{ tag }}</span>
              </div>
            </div>
          </div>
        </div>
      </section>
  
      <section class="featured-food-section" v-if="selectedFood !== null">
        <div class="featured-container">
          <button class="close-button" @click="selectedFood = null">×</button>
          <div class="featured-content">
            <div class="featured-image">
              <img :src="foods[selectedFood].image" :alt="foods[selectedFood].name">
            </div>
            <div class="featured-details">
              <h2 class="featured-title">{{ foods[selectedFood].name }}</h2>
              <div class="featured-region">{{ foods[selectedFood].region }}</div>
              <p class="featured-desc">{{ foods[selectedFood].fullDescription || foods[selectedFood].description }}</p>
              
              <div class="featured-info">
                <div class="info-section">
                  <h4>主要食材</h4>
                  <ul class="ingredients-list">
                    <li v-for="(ingredient, i) in foods[selectedFood].ingredients" :key="i">{{ ingredient }}</li>
                  </ul>
                </div>
                
                <div class="info-section">
                  <h4>口味特点</h4>
                  <div class="taste-tags">
                    <span class="taste-tag" v-for="(taste, i) in foods[selectedFood].taste" :key="i">{{ taste }}</span>
                  </div>
                </div>
                
                <div class="info-section">
                  <h4>最佳品尝季节</h4>
                  <p>{{ foods[selectedFood].season }}</p>
                </div>
              </div>
              
              <div class="featured-history" v-if="foods[selectedFood].history">
                <h4>历史渊源</h4>
                <p>{{ foods[selectedFood].history }}</p>
              </div>
            </div>
          </div>
        </div>
      </section>
  
      <footer class="footer">
        <div class="footer-content">
          <p>山西省文化和旅游厅 © 2023 版权所有</p>
          <p>地址：山西省太原市迎泽区迎泽大街369号 | 电话：0351-12345678</p>
        </div>
      </footer>
    </div>
</template>
  
<script setup>
  import { ref, computed } from 'vue';
  
  const selectedFood = ref(null);
  const activeFilter = ref('all');
  
  const foods = [
    {
      name: "刀削面",
      image: "/images/十八种美食/刀削面.png",
      region: "太原市",
      description: "山西最具代表性的面食，以刀削制作工艺闻名，面条宽厚中间薄，入口筋道爽滑。",
      fullDescription: "刀削面是山西最具代表性的传统面食，距今已有3000多年历史。其特点是师傅手持特制的刀，将和好的面团架在左肩上，右手持刀在面团上快速削下薄片，落入沸水中煮熟。成品面条外形似柳叶，中间薄、边缘厚，口感筋道爽滑，入口有嚼劲。通常配以各种汤料食用，如牛肉、羊肉、番茄鸡蛋等。",
      ingredients: ["面粉", "水", "盐", "各种配料"],
      taste: ["筋道", "爽滑", "有嚼劲"],
      season: "四季皆宜",
      history: "刀削面起源于明代，相传是明朝山西洪洞县一位叫郭朴的厨师发明的。当时他为了给明太祖朱元璋做寿面，创造性地用刀削出了薄如纸的面片，获得了皇帝的赞赏。",
      tags: ["面食", "传统", "技艺"],
      type: "noodles"
    },
    {
      name: "山西老陈醋",
      image: "/images/十八种美食/山西老陈醋.png",
      region: "清徐县",
      description: "中国四大名醋之首，以色、香、味、形俱佳著称，酸而不涩，香而微甜。",
      fullDescription: "山西老陈醋是中国四大名醋之首，主要产于太原市清徐县，有着3000多年的酿造历史。采用高粱、大麦、豌豆等为原料，经过蒸料、制曲、糖化、发酵、陈酿等多道工序精制而成。其特点是色泽黑褐，清亮透明，酸味醇厚，香气浓郁，回味悠长。山西人几乎每餐必用醋，有'无醋不成席'的说法。",
      ingredients: ["高粱", "大麦", "豌豆", "麸皮"],
      taste: ["酸", "香", "醇厚", "回甘"],
      season: "四季皆宜",
      history: "山西老陈醋的酿造技艺始于东周春秋时期，距今已有3000多年历史。相传周幽王时期，晋国大夫介子推曾用醋救治周幽王的病，从此醋便在山西广为流传。",
      tags: ["调味品", "传统", "工艺"],
      type: "dishes"
    },
    {
      name: "太谷饼",
      image: "/images/十八种美食/太谷饼.png",
      region: "晋中市太谷县",
      description: "山西著名的传统糕点，外皮酥脆，内馅香甜，层次分明，回味无穷。",
      fullDescription: "太谷饼是山西省晋中市太谷县的传统名点，已有300多年历史。其特点是外皮金黄酥脆，内馅香甜适口，层次分明。制作工艺精细，选用优质面粉、白糖、猪油、芝麻等原料，经过和面、制馅、包制、烘烤等多道工序精制而成。太谷饼不仅是当地人招待贵客的佳品，也是馈赠亲友的上等礼品。",
      ingredients: ["面粉", "白糖", "猪油", "芝麻", "核桃仁"],
      taste: ["酥脆", "香甜", "层次分明"],
      season: "四季皆宜，尤以秋冬为佳",
      history: "太谷饼起源于清朝康熙年间，由太谷县城关镇的张氏家族创制。最初是为了祭祀先祖而制作的供品，后来逐渐发展成为著名的地方特色小吃。",
      tags: ["糕点", "传统", "甜食"],
      type: "snacks"
    },
    {
      name: "平遥牛肉",
      image: "/images/十八种美食/平遥牛肉.png",
      region: "晋中市平遥县",
      description: "色泽红亮，肉质细嫩，香气浓郁，咸中带甜，是平遥古城的著名特产。",
      fullDescription: "平遥牛肉是山西省晋中市平遥县的传统名吃，已有400多年历史。选用优质牛肉，经过腌制、煮制、晾晒等多道工序精制而成。其特点是色泽红亮，肉质细嫩，香气浓郁，咸中带甜，回味无穷。平遥牛肉既可冷食，也可热炒，是平遥古城最具代表性的美食之一。",
      ingredients: ["牛肉", "酱油", "白糖", "花椒", "八角", "桂皮"],
      taste: ["咸鲜", "微甜", "香辣", "醇厚"],
      season: "四季皆宜，尤以冬季为佳",
      history: "平遥牛肉起源于明代万历年间，相传是由平遥县城内的牛肉店老板为了保存牛肉而发明的。经过数百年的传承和发展，已成为平遥古城的标志性美食。",
      tags: ["肉食", "传统", "名吃"],
      type: "dishes"
    },
    {
      name: "莜面栲栳栳",
      image: "/images/十八种美食/莜面栲栳栳.png",
      region: "忻州市",
      description: "以莜麦面为主料，形似花篮，口感筋道，是山西北部地区的传统面食。",
      fullDescription: "莜面栲栳栳是山西北部地区的传统面食，主要流行于忻州、大同等地。以莜麦面为主料，经过和面、搓条、编织等工序制成，形状似花篮，故名\"栲栳栳\"。成品色泽淡黄，口感筋道，富含蛋白质和多种微量元素，营养价值高。通常配以醋、蒜泥、辣椒油等调料食用，也可配以各种炒菜。",
      ingredients: ["莜麦面", "水", "盐"],
      taste: ["筋道", "清香", "爽滑"],
      season: "四季皆宜，尤以冬季为佳",
      history: "莜面栲栳栳起源于北方游牧民族，后来逐渐融入山西北部地区的饮食文化。相传最初是牧民为了方便携带食物而发明的，将面条编织成篮状，既可盛汤，又可直接食用。",
      tags: ["面食", "传统", "特色"],
      type: "noodles"
    },
    {
      name: "太原头脑",
      image: "/images/十八种美食/太原头脑.png",
      region: "太原市",
      description: "太原特色小吃，以羊杂碎为主料，汤鲜味美，营养丰富，被誉为\"太原第一汤\"。",
      fullDescription: "太原头脑是太原市的传统特色小吃，以羊头肉、羊杂碎为主料，加入多种香料熬制而成。汤色乳白，味道鲜美，营养丰富，被誉为\"太原第一汤\"。太原头脑通常在早晨食用，具有暖胃驱寒、滋补养生的功效，深受当地人喜爱。",
      ingredients: ["羊头肉", "羊杂碎", "葱", "姜", "蒜", "花椒", "八角"],
      taste: ["鲜美", "浓郁", "微辣"],
      season: "四季皆宜，尤以冬季为佳",
      history: "太原头脑起源于清代，最初是太原城内的小摊贩为了充分利用羊的各个部位而创制的。因其汤品营养丰富，有\"喝了长头脑\"之说，故名\"头脑\"。",
      tags: ["汤品", "传统", "早餐"],
      type: "dishes"
    },
    {
      name: "晋味灌肠",
      image: "/images/十八种美食/晋味灌肠.png",
      region: "太原市",
      description: "以猪大肠为外皮，灌入糯米、猪血等制成，口感软糯，味道鲜美。",
      fullDescription: "晋味灌肠是山西太原的传统特色小吃，以猪大肠为外皮，灌入糯米、猪血、葱姜蒜等制成。制作工艺精细，需要经过洗肠、灌制、蒸煮等多道工序。成品色泽红褐，口感软糯，味道鲜美，通常切片后蘸以醋、蒜泥、辣椒油等调料食用。",
      ingredients: ["猪大肠", "糯米", "猪血", "葱", "姜", "蒜"],
      taste: ["软糯", "鲜美", "微辣"],
      season: "四季皆宜",
      history: "晋味灌肠起源于明清时期，是山西民间充分利用猪下水的智慧结晶。最初是为了解决肉食短缺问题而创制的，后来逐渐发展成为具有地方特色的美食。",
      tags: ["小吃", "传统", "特色"],
      type: "snacks"
    },
    {
      name: "碗秃",
      image: "/images/十八种美食/碗秃.png",
      region: "临汾市",
      description: "临汾地区特色面食，面皮薄如纸，叠成层层褶皱，口感筋道，汤汁鲜美。",
      fullDescription: "碗秃是山西临汾地区的特色面食，因其形状像倒扣的碗而得名。制作时将和好的面团擀成薄如纸的面皮，然后叠成层层褶皱，放入碗中蒸熟，食用时倒扣在盘中，浇上各种调料汤汁。成品外形美观，面皮薄而有韧性，口感筋道，汤汁鲜美，是临汾地区招待贵客的传统美食。",
      ingredients: ["面粉", "水", "盐", "各种调料"],
      taste: ["筋道", "鲜美", "爽滑"],
      season: "四季皆宜",
      history: "碗秃起源于明代，相传是临汾地区的民间厨师为了招待官员而创制的。因其形似倒扣的碗，且吃完后碗中无剩余，故名\"碗秃\"。",
      tags: ["面食", "传统", "特色"],
      type: "noodles"
    },
    {
      name: "面皮",
      image: "/images/十八种美食/面皮.png",
      region: "运城市",
      description: "运城地区特色小吃，面皮柔韧爽滑，配以特制调料，酸辣可口，开胃爽口。",
      fullDescription: "面皮是山西运城地区的特色小吃，以优质面粉为原料，经过和面、蒸制、冷却、切条等工序制成。成品色泽洁白，质地柔韧，口感爽滑。食用时配以特制的调料汁，包括醋、蒜泥、辣椒油、芝麻酱等，酸辣可口，开胃爽口，是夏季消暑的理想小吃。",
      ingredients: ["面粉", "水", "盐", "醋", "蒜泥", "辣椒油", "芝麻酱"],
      taste: ["酸辣", "爽滑", "开胃"],
      season: "四季皆宜，尤以夏季为佳",
      history: "面皮起源于明清时期，最初是运城地区农民的日常食品。因其制作简单，原料易得，且口感独特，逐渐发展成为具有地方特色的美食。",
      tags: ["小吃", "传统", "凉菜"],
      type: "snacks"
    },
    {
      name: "过油肉",
      image: "/images/十八种美食/过油肉.png",
      region: "长治市",
      description: "长治地区传统名菜，肉质酥脆，味道鲜美，色泽金黄，是招待贵客的佳肴。",
      fullDescription: "过油肉是山西长治地区的传统名菜，选用优质猪肉，切成薄片，经过腌制、裹粉、油炸等工序制成。成品色泽金黄，外酥里嫩，味道鲜美，香气扑鼻。通常配以特制的汁料食用，酸甜适口，回味无穷，是长治地区招待贵客的传统佳肴。",
      ingredients: ["猪肉", "面粉", "鸡蛋", "酱油", "醋", "白糖"],
      taste: ["酥脆", "鲜美", "酸甜"],
      season: "四季皆宜",
      history: "过油肉起源于清代，相传是长治地区的厨师为了招待官员而创制的。因其制作工艺独特，口感极佳，逐渐成为长治地区的代表性菜肴。",
      tags: ["肉食", "传统", "名菜"],
      type: "dishes"
    },
    {
      name: "猫耳朵",
      image: "/images/十八种美食/猫耳朵.png",
      region: "吕梁市",
      description: "形似猫耳的特色面食，口感筋道，配以各种汤料，味道鲜美，深受喜爱。",
      fullDescription: "猫耳朵是山西吕梁地区的特色面食，因其形状似猫的耳朵而得名。制作时将和好的面团揪成小块，用拇指和食指捏成猫耳状，下入沸水煮熟。成品形态可爱，口感筋道，通常配以各种汤料食用，如番茄鸡蛋、肉末、蔬菜等，味道鲜美，深受当地人喜爱。",
      ingredients: ["面粉", "水", "盐", "各种配料"],
      taste: ["筋道", "鲜美", "爽口"],
      season: "四季皆宜",
      history: "猫耳朵起源于民间，是山西农村地区的传统家常面食。因其制作简单，形态可爱，且口感独特，逐渐成为吕梁地区的特色美食。",
      tags: ["面食", "传统", "家常"],
      type: "noodles"
    },
    {
      name: "臊子面",
      image: "/images/十八种美食/臊子面.png",
      region: "晋城市",
      description: "晋城地区特色面食，以肉臊子为主料，汤鲜味美，营养丰富，是当地人喜爱的日常食品。",
      fullDescription: "臊子面是山西晋城地区的特色面食，以手工制作的面条为主料，配以特制的肉臊子。肉臊子由猪肉末、豆腐丁、木耳、胡萝卜等多种食材炒制而成，色香味俱佳。食用时将煮熟的面条捞出，浇上肉臊子和汤汁，再撒上葱花、香菜等点缀，汤鲜味美，营养丰富，是晋城地区人们喜爱的日常食品。",
      ingredients: ["面粉", "猪肉末", "豆腐", "木耳", "胡萝卜", "葱", "蒜"],
      taste: ["鲜美", "浓郁", "咸香"],
      season: "四季皆宜",
      history: "臊子面起源于明清时期，是晋城地区农民的传统食品。因其制作简单，原料易得，且营养丰富，逐渐成为晋城地区的代表性美食。",
      tags: ["面食", "传统", "家常"],
      type: "noodles"
    },
    {
      name: "油茶面",
      image: "/images/十八种美食/油茶面.png",
      region: "朔州市",
      description: "朔州地区特色面食，以面粉、油、茶叶为主料，香气浓郁，味道独特，营养丰富。",
      fullDescription: "油茶面是山西朔州地区的特色面食，以面粉、食用油、茶叶为主要原料制作而成。制作时先将茶叶煮出浓汁，然后加入油和面粉搅拌均匀，形成糊状。成品色泽金黄，香气浓郁，味道独特，既有茶的清香，又有油的醇厚。油茶面营养丰富，具有暖胃驱寒的功效，是朔州地区冬季的传统早餐。",
      ingredients: ["面粉", "食用油", "茶叶", "盐", "葱花"],
      taste: ["香浓", "醇厚", "独特"],
      season: "四季皆宜，尤以冬季为佳",
      history: "油茶面起源于北方游牧民族，后来融入朔州地区的饮食文化。相传最初是牧民为了抵御寒冷而发明的，具有很高的热量和营养价值。",
      tags: ["面食", "传统", "早餐"],
      type: "noodles"
    },
    {
      name: "蒸肉",
      image: "/images/十八种美食/蒸肉.png",
      region: "阳泉市",
      description: "阳泉地区传统名菜，肉质酥烂，味道鲜美，香气扑鼻，是招待贵客的佳肴。",
      fullDescription: "蒸肉是山西阳泉地区的传统名菜，选用优质猪肉，切成大块，经过腌制、蒸煮等工序制成。制作时加入多种香料和调味品，如八角、桂皮、花椒、酱油等，使肉质入味。成品色泽红亮，肉质酥烂，味道鲜美，香气扑鼻，是阳泉地区招待贵客的传统佳肴。",
      ingredients: ["猪肉", "酱油", "白糖", "八角", "桂皮", "花椒"],
      taste: ["酥烂", "鲜美", "香浓"],
      season: "四季皆宜，尤以冬季为佳",
      history: "蒸肉起源于明清时期，是阳泉地区民间的传统菜肴。因其制作工艺独特，口感极佳，逐渐成为阳泉地区的代表性美食。",
      tags: ["肉食", "传统", "名菜"],
      type: "dishes"
    },
    {
      name: "黄芽菜",
      image: "/images/十八种美食/黄芽菜.png",
      region: "晋城市陵川县",
      description: "晋城陵川特产，以嫩黄芽菜腌制而成，口感脆嫩，味道酸甜，是著名的开胃菜。",
      fullDescription: "黄芽菜是山西晋城市陵川县的特产，以当地特有的嫩黄芽菜为原料，经过腌制、发酵等工序制成。制作时加入适量的盐、糖、醋等调味品，使菜品入味。成品色泽金黄，口感脆嫩，味道酸甜适口，是著名的开胃菜，也是陵川县的地理标志产品。",
      ingredients: ["黄芽菜", "盐", "糖", "醋"],
      taste: ["酸甜", "脆嫩", "开胃"],
      season: "春季为佳",
      history: "黄芽菜起源于明清时期，是陵川县农民为了保存蔬菜而发明的。因其独特的口感和风味，逐渐成为陵川县的代表性特产。",
      tags: ["腌菜", "传统", "特产"],
      type: "dishes"
    },
    {
      name: "柳林薄饼",
      image: "/images/十八种美食/柳林博饼.png",
      region: "吕梁市柳林县",
      description: "柳林县特色小吃，饼薄如纸，层次分明，口感酥脆，味道香甜，是当地著名的传统美食。",
      fullDescription: "柳林薄饼是山西吕梁市柳林县的特色小吃，以优质面粉为主料，经过和面、擀制、烙烤等工序制成。成品薄如纸，层次分明，口感酥脆，味道香甜。柳林薄饼可以直接食用，也可以夹入各种馅料，如豆沙、肉末等，风味更佳。是柳林县的传统美食，也是馈赠亲友的佳品。",
      ingredients: ["面粉", "食用油", "白糖", "芝麻"],
      taste: ["酥脆", "香甜", "层次分明"],
      season: "四季皆宜",
      history: "柳林薄饼起源于明代，相传是柳林县的民间厨师为了招待官员而创制的。因其制作工艺精细，口感独特，逐渐成为柳林县的代表性美食。",
      tags: ["糕点", "传统", "特色"],
      type: "snacks"
    },
    {
      name: "五台山素食",
      image: "/images/十八种美食/五台山素食.png",
      region: "忻州市五台山",
      description: "五台山佛教素食，以素材模仿荤菜，色香味俱佳，是佛教饮食文化的代表。",
      fullDescription: "五台山素食是山西忻州市五台山的特色美食，是佛教饮食文化的重要组成部分。五台山素食以素材模仿荤菜，通过精湛的烹饪技艺，使素菜具有荤菜的口感和风味。常见的五台山素食有素鸡、素鸭、素鱼等，色香味俱佳，营养丰富，是五台山寺庙招待游客的特色美食。",
      ingredients: ["豆制品", "面筋", "蔬菜", "菌类", "各种调料"],
      taste: ["鲜美", "清淡", "健康"],
      season: "四季皆宜",
      history: "五台山素食起源于佛教文化，有着悠久的历史。五台山作为中国四大佛教名山之一，素食文化极为发达。寺庙厨师通过不断创新和发展，形成了独具特色的五台山素食体系。",
      tags: ["素食", "佛教", "健康"],
      type: "dishes"
    },
    {
      name: "运城麻片",
      image: "/images/十八种美食/运城麻片.png",
      region: "运城市",
      description: "运城特色糕点，外酥内软，香甜可口，芝麻香浓，是著名的传统小吃。",
      fullDescription: "运城麻片是山西运城市的特色糕点，以面粉、白糖、芝麻为主要原料制作而成。制作工艺精细，需要经过和面、擀制、烘烤等多道工序。成品外形美观，表面撒满芝麻，外酥内软，香甜可口，芝麻香浓。运城麻片不仅是当地人喜爱的传统小吃，也是馈赠亲友的佳品。",
      ingredients: ["面粉", "白糖", "芝麻", "食用油"],
      taste: ["酥脆", "香甜", "芝麻香"],
      season: "四季皆宜",
      history: "运城麻片起源于清代，相传是运城地区的糕点师为了招待官员而创制的。因其制作工艺独特，口感极佳，逐渐成为运城市的代表性特色小吃。",
      tags: ["糕点", "传统", "特色"],
      type: "snacks"
    }
  ];
  
  // 根据筛选条件过滤美食
  const filteredFoods = computed(() => {
    if (activeFilter.value === 'all') {
      return foods;
    } else {
      return foods.filter(food => food.type === activeFilter.value);
    }
  });
  
  // 选择美食
  const selectFood = (index) => {
    selectedFood.value = index;
    // 滚动到详情区域
    setTimeout(() => {
      const featuredSection = document.querySelector('.featured-food-section');
      if (featuredSection) {
        featuredSection.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  };
</script>
  
<style>
  /* 全局样式 */
  :root {
    --primary-color: #c62f2f;
    --secondary-color: #f8b400;
    --text-color: #333;
    --light-text: #666;
    --background-color: #f9f5f0;
    --card-bg: #fff;
    --border-color: #e0d6c8;
    --shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    --transition: all 0.3s ease;
  }
  
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
  
  body {
    font-family: "Noto Serif SC", "SimSun", serif;
    color: var(--text-color);
    background-color: var(--background-color);
    line-height: 1.6;
  }
  
  img {
    max-width: 100%;
    height: auto;
    display: block;
  }
  
  button {
    cursor: pointer;
    font-family: inherit;
  }
  
  /* 页面容器 */
  .food-map-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
  }
  
  /* 头部样式 */
  .food-header {
    padding: 60px 0;
    text-align: center;
    background: url('https://via.placeholder.com/1200x300') no-repeat center center;
    background-size: cover;
    position: relative;
    margin-bottom: 40px;
  }
  
  .food-header::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
  }
  
  .header-content {
    position: relative;
    z-index: 1;
    color: white;
  }
  
  .main-title {
    font-size: 42px;
    font-weight: bold;
    margin-bottom: 16px;
    letter-spacing: 4px;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  }
  
  .subtitle {
    font-size: 18px;
    max-width: 600px;
    margin: 0 auto;
  }
  
  /* 介绍部分 */
  .intro-section {
    margin-bottom: 60px;
  }
  
  .intro-content {
    display: flex;
    flex-direction: column;
    gap: 30px;
  }
  
  @media (min-width: 768px) {
    .intro-content {
      flex-direction: row;
    }
  }
  
  .intro-text {
    flex: 2;
  }
  
  .intro-text h2 {
    font-size: 28px;
    margin-bottom: 20px;
    color: var(--primary-color);
  }
  
  .intro-text p {
    margin-bottom: 16px;
    line-height: 1.8;
  }
  
  .intro-stats {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 20px;
    justify-content: center;
  }
  
  .stat-item {
    text-align: center;
    padding: 20px;
    background-color: var(--card-bg);
    border-radius: 8px;
    box-shadow: var(--shadow);
  }
  
  .stat-number {
    font-size: 36px;
    font-weight: bold;
    color: var(--primary-color);
    margin-bottom: 8px;
  }
  
  .stat-label {
    font-size: 16px;
    color: var(--light-text);
  }
  
  /* 章节标题 */
  .section-title {
    font-size: 28px;
    margin-bottom: 30px;
    text-align: center;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .title-icon {
    margin-right: 10px;
    font-size: 24px;
  }
  
  .title-line {
    height: 2px;
    background-color: var(--secondary-color);
    width: 60px;
    margin: 0 auto;
    margin-top: 10px;
  }
  
  /* 地图部分 */
  .map-section {
    margin-bottom: 60px;
  }
  
  .map-container {
    position: relative;
    margin: 0 auto;
    max-width: 800px;
  }
  
  .shanxi-map {
    position: relative;
    width: 100%;
    height: 600px;
    background-color: var(--card-bg);
    border-radius: 8px;
    box-shadow: var(--shadow);
    overflow: hidden;
  }
  
  .map-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  
  .map-marker {
    position: absolute;
    transform: translate(-50%, -50%);
    cursor: pointer;
    z-index: 2;
  }
  
  .marker-dot {
    width: 16px;
    height: 16px;
    background-color: var(--primary-color);
    border-radius: 50%;
    border: 2px solid white;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
    margin: 0 auto 4px;
    transition: var(--transition);
  }
  
  .marker-label {
    font-size: 12px;
    color: var(--text-color);
    background-color: white;
    padding: 2px 6px;
    border-radius: 4px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    white-space: nowrap;
    text-align: center;
  }
  
  .map-marker:hover .marker-dot {
    transform: scale(1.2);
    background-color: var(--secondary-color);
  }
  
  /* 美食列表部分 */
  .food-list-section {
    margin-bottom: 60px;
  }
  
  .food-filter {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    gap: 10px;
    margin-bottom: 30px;
  }
  
  .filter-button {
    padding: 8px 16px;
    background-color: var(--card-bg);
    border: 1px solid var(--border-color);
    border-radius: 4px;
    font-size: 14px;
    transition: var(--transition);
  }
  
  .filter-button.active {
    background-color: var(--primary-color);
    color: white;
    border-color: var(--primary-color);
  }
  
  .filter-button:hover:not(.active) {
    background-color: #f0f0f0;
  }
  
  .food-grid {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    gap: 20px;
  }
  
  @media (min-width: 576px) {
    .food-grid {
      grid-template-columns: repeat(2, 1fr);
    }
  }
  
  @media (min-width: 992px) {
    .food-grid {
      grid-template-columns: repeat(3, 1fr);
    }
  }
  
  .food-card {
    background-color: var(--card-bg);
    border-radius: 8px;
    overflow: hidden;
    box-shadow: var(--shadow);
    transition: var(--transition);
    cursor: pointer;
  }
  
  .food-card:hover, .food-card.active {
    transform: translateY(-5px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  }
  
  .food-card.active {
    border: 2px solid var(--primary-color);
  }
  
  .food-image {
    position: relative;
    height: 200px;
    overflow: hidden;
  }
  
  .food-image img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: var(--transition);
  }
  
  .food-card:hover .food-image img {
    transform: scale(1.05);
  }
  
  .food-region {
    position: absolute;
    top: 10px;
    right: 10px;
    background-color: rgba(0, 0, 0, 0.6);
    color: white;
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 12px;
  }
  
  .food-content {
    padding: 16px;
  }
  
  .food-title {
    font-size: 18px;
    margin-bottom: 8px;
    color: var(--primary-color);
  }
  
  .food-desc {
    font-size: 14px;
    color: var(--light-text);
    margin-bottom: 12px;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
  
  .food-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
  }
  
  .food-tag {
    font-size: 12px;
    background-color: #f0f0f0;
    padding: 2px 8px;
    border-radius: 4px;
    color: var(--light-text);
  }
  
  /* 特色美食详情 */
  .featured-food-section {
    margin-bottom: 60px;
  }
  
  .featured-container {
    background-color: var(--card-bg);
    border-radius: 8px;
    box-shadow: var(--shadow);
    padding: 30px;
    position: relative;
  }
  
  .close-button {
    position: absolute;
    top: 20px;
    right: 20px;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background-color: #f0f0f0;
    border: none;
    font-size: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: var(--transition);
  }
  
  .close-button:hover {
    background-color: #e0e0e0;
  }
  
  .featured-content {
    display: flex;
    flex-direction: column;
    gap: 30px;
  }
  
  @media (min-width: 768px) {
    .featured-content {
      flex-direction: row;
    }
  }
  
  .featured-image {
    flex: 1;
    border-radius: 8px;
    overflow: hidden;
  }
  
  .featured-image img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  
  .featured-details {
    flex: 2;
  }
  
  .featured-title {
    font-size: 28px;
    margin-bottom: 8px;
    color: var(--primary-color);
  }
  
  .featured-region {
    font-size: 16px;
    color: var(--secondary-color);
    margin-bottom: 16px;
  }
  
  .featured-desc {
    font-size: 16px;
    line-height: 1.8;
    margin-bottom: 24px;
  }
  
  .featured-info {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    gap: 20px;
    margin-bottom: 24px;
  }
  
  @media (min-width: 576px) {
    .featured-info {
      grid-template-columns: repeat(2, 1fr);
    }
  }
  
  @media (min-width: 992px) {
    .featured-info {
      grid-template-columns: repeat(3, 1fr);
    }
  }
  
  .info-section h4 {
    font-size: 16px;
    margin-bottom: 10px;
    color: var(--primary-color);
  }
  
  .ingredients-list {
    list-style-type: none;
  }
  
  .ingredients-list li {
    margin-bottom: 6px;
    font-size: 14px;
    position: relative;
    padding-left: 16px;
  }
  
  .ingredients-list li::before {
    content: '•';
    position: absolute;
    left: 0;
    color: var(--secondary-color);
  }
  
  .taste-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
  }
  
  .taste-tag {
    font-size: 14px;
    background-color: #f0f0f0;
    padding: 4px 10px;
    border-radius: 4px;
    color: var(--text-color);
  }
  
  .featured-history h4 {
    font-size: 16px;
    margin-bottom: 10px;
    color: var(--primary-color);
  }
  
  .featured-history p {
    font-size: 14px;
    line-height: 1.7;
  }
  
  /* 页脚样式 */
  .footer {
    background-color: #2c2c2c;
    color: #aaa;
    padding: 30px 0;
    text-align: center;
    font-size: 14px;
    margin-top: 60px;
  }
  
  .footer-content {
    max-width: 800px;
    margin: 0 auto;
  }
  
  .footer p {
    margin-bottom: 8px;
  }
</style>